import React from 'react';

interface SigningBottomBarProps {
  signaturePreview: string;
  onChangeSignature: () => void;
  onSign: () => void;
  signing: boolean;
  isLastDocument: boolean;
}

const SigningBottomBar: React.FC<SigningBottomBarProps> = ({
  signaturePreview,
  onChangeSignature,
  onSign,
  signing,
  isLastDocument,
}) => {
  const buttonLabel = isLastDocument ? 'Sign & Finish' : 'Sign & Next';

  return (
    <div style={styles.container}>
      <div style={styles.signatureRow}>
        <span style={styles.signatureLabel}>Signature:</span>
        <img
          src={signaturePreview}
          alt="Your signature"
          style={styles.signaturePreviewImg}
        />
        <button
          type="button"
          style={styles.changeButton}
          onClick={onChangeSignature}
        >
          Change
        </button>
      </div>

      <button
        type="button"
        style={{
          ...styles.signButton,
          opacity: signing ? 0.6 : 1,
        }}
        disabled={signing}
        onClick={onSign}
      >
        {signing ? (
          <div style={styles.spinnerContainer}>
            <div style={styles.spinner} />
            <span>Signing...</span>
          </div>
        ) : (
          buttonLabel
        )}
      </button>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: '#ffffff',
    borderTop: '1px solid #e5e5e5',
    padding: '12px 20px',
    paddingBottom: 'calc(16px + env(safe-area-inset-bottom))',
    zIndex: 20,
  },
  signatureRow: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginBottom: 12,
  },
  signatureLabel: {
    fontSize: 14,
    color: '#6b7280',
    fontWeight: 500,
  },
  signaturePreviewImg: {
    height: 40,
    maxWidth: 120,
    objectFit: 'contain',
    border: '1px solid #e5e7eb',
    borderRadius: 6,
    backgroundColor: '#ffffff',
    padding: 2,
  },
  changeButton: {
    marginLeft: 'auto',
    background: 'none',
    border: 'none',
    color: '#2563eb',
    fontSize: 14,
    fontWeight: 500,
    cursor: 'pointer',
    padding: '4px 8px',
  },
  signButton: {
    width: '100%',
    height: 52,
    borderRadius: 12,
    backgroundColor: '#2563eb',
    color: '#ffffff',
    fontSize: 17,
    fontWeight: 600,
    border: 'none',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  spinnerContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 8,
  },
  spinner: {
    width: 18,
    height: 18,
    border: '2px solid rgba(255,255,255,0.3)',
    borderTopColor: '#ffffff',
    borderRadius: '50%',
    animation: 'spin 0.8s linear infinite',
  },
};

export default SigningBottomBar;
